// Pull the first human-readable string out of a DRF-style error value, which
// may be a string, an array of strings, or a { field: [messages] } map such as
// { email: ['A user is already registered with this e-mail address.'] }.
const firstMessage = (value) => {
  if (!value) return undefined
  if (typeof value === 'string') return value
  if (Array.isArray(value)) return firstMessage(value.find(Boolean))
  if (typeof value === 'object') {
    // Prefer DRF's well-known keys, then fall back to the first field's error.
    const candidates = [
      value.detail,
      value.non_field_errors,
      value.nonFieldErrors,
      value.error,
      ...Object.values(value)
    ]
    return candidates.map(firstMessage).find(Boolean)
  }
  return undefined
}

// Extract a user-facing message from a fetchHelper failure payload
// ({ value, status }) or a raw response body, falling back to defaultMessage.
const getErrorMessage = (payload, defaultMessage = 'An error occurred.') => {
  if (!payload) return defaultMessage
  const body = payload.value !== undefined ? payload.value : payload
  return firstMessage(body) || defaultMessage
}

export default getErrorMessage
